
var convert = require('./convert');
var parse = require('./parse');

/**
 * Expose `convert`.
 */

exports.convert = convert;

/**
 * Expose `parse`.
 */

exports.parse = parse;


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-color-function/lib/index.js
 ** module id = 234
 ** module chunks = 0
 **/